<template>
  <div class="home-container">
    <div 
      :class="{'col-span-5': showSuccessScreen, 'col-span-2': !showSuccessScreen}" 
      class="cover-container"
    >
    </div>

    <div 
      :class="{'col-span-7 flex-grow': showSuccessScreen, 'col-span-3': !showSuccessScreen}" 
      class="middle-container bg-primary"
    >
      <router-link :to="{name: 'home'}">
        <Logo />
      </router-link>

      <h1 v-if="!showSuccessScreen" class="mt-5 text-2xl font-bold leading-10 text-white font-title md:text-3xl">
        {{ $translations.logInSignUp.sign_up_title }}
      </h1>

      <BackButton v-if="!showSuccessScreen" class-list="text-white mb-3 pl-0" />

      <p v-if="!showSuccessScreen" class="text-sm leading-8 text-white md:text-xl">
        {{ $translations.shared.about.worker.paragraph_one }}
      </p>
      <p v-if="!showSuccessScreen" class="mt-4 text-sm leading-8 text-white md:text-xl">
        {{ $translations.shared.about.worker.paragraph_two }}
      </p>

      <i18n 
        v-if="!showSuccessScreen" 
        path="shared.about.worker.paragraph_three" 
        tag="p" 
        class="mt-4 text-sm leading-8 text-white md:text-xl"
      >
        <br>
        <strong class="italic lowercase">{{ $translations.shared.app_name }}</strong>
      </i18n>

      <div v-if="showSuccessScreen" class="max-w-2xl text-white bg-primary">
        <h1 class="mt-5 text-2xl font-bold text-white font-title">
          {{ $translations.shared.congratulations }}
        </h1>

        <p class="my-5">
          {{ $translations.logInSignUp.sign_up_confirmation[0] }}
          <span class="font-bold">{{ $translations.logInSignUp.sign_up_confirmation[1] }}</span>
          {{ $translations.logInSignUp.sign_up_confirmation[2] }}
        </p>

        <router-link class="button white" :to="{name: 'home'}">
          {{ $translations.shared.buttons.back }}
        </router-link>
      </div>
    </div>

    <div v-if="!showSuccessScreen" class="col-span-7 main-container has-form xl:px-10">
      <div class="max-w-2xl mx-auto">
        <WorkerSignUpForm @on-submit="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from '@/components/shared/images/Logo.vue';
  import BackButton from '@/components/shared/utils/BackButton.vue';
  import WorkerSignUpForm from '@/components/worker/WorkerSignUpForm.vue';

  import { api, formDataGenerator } from '@/helpers';

  export default {
    name: 'WorkerSignUp',
    components: {
      Logo,
      BackButton,
      WorkerSignUpForm
    },
    props: {},
    data: () => {
      return {
        showSuccessScreen: false 
      };
    },
    methods: {
      async onSubmit(worker) {
        const formData = formDataGenerator(worker, 'user');
        const response = await api.post('/users/sign_up', formData);
        if (response.data) {
          this.showSuccessScreen = true;
        }
      }
    }
  };
</script>
